/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the operator sees the value.
 */
export const WorkloadPlatformConstantVisibility = {
  Hidden: "hidden",
  ReadOnly: "read-only",
} as const;
/**
 * Whether the operator sees the value.
 */
export type WorkloadPlatformConstantVisibility = OpenEnum<
  typeof WorkloadPlatformConstantVisibility
>;

/**
 * A value a catalog platform supplies, the same for every customer.
 */
export type WorkloadPlatformConstant = {
  /**
   * The value, with {key} placeholders for platform-tier variables.
   */
  value: string;
  /**
   * Whether the operator sees the value.
   */
  visibility: WorkloadPlatformConstantVisibility;
};

/** @internal */
export const WorkloadPlatformConstantVisibility$inboundSchema: z.ZodMiniType<
  WorkloadPlatformConstantVisibility,
  unknown
> = openEnums.inboundSchema(WorkloadPlatformConstantVisibility);

/** @internal */
export const WorkloadPlatformConstant$inboundSchema: z.ZodMiniType<
  WorkloadPlatformConstant,
  unknown
> = z.object({
  value: z.string(),
  visibility: WorkloadPlatformConstantVisibility$inboundSchema,
});

export function workloadPlatformConstantFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformConstant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformConstant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformConstant' from JSON`,
  );
}
